module.exports = __webpack_public_path__ + "img/tube8.fa7792f.png";